import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';

import {PersonalPlanLandingPageProps} from '../../personal-plan-landing-page-body.react-component';
import styles from './collection-title.module.less';

export interface CollectionTitleProps extends PersonalPlanLandingPageProps {
    className?: string;
}

export const CollectionTitle = ({className, isPPLPRevamp}: CollectionTitleProps) => {
    const {gettext} = useI18n();

    return (
        <div className={classNames(className, {[styles.revamp]: isPPLPRevamp})}>
            <h2
                className={classNames(
                    styles['collection-title'],
                    !isPPLPRevamp && 'ud-heading-serif-xl',
                )}
            >
                {gettext('Get a peek at the collection')}
            </h2>
            <p className={classNames(styles['collection-desc'], 'ud-text-md')}>
                {gettext(
                    'With thousands of our best-rated courses from top Udemy instructors, Personal Plan is your subscription to success. Explore some of the included content below.',
                )}
            </p>
        </div>
    );
};
